module.exports = __webpack_public_path__ + "static/img/torsoScaled2.a2a0908d.jpg";